export default [
  {
    path: 'chargeReportSummary',
    name: 'chargeReportSummary',
    component: () => import('./views/chargeReportSummary'),
    meta: {
      title: '收费报表汇总'
    }
  },
  {
    path: 'summaryOfPayment',
    name: 'summaryOfPayment',
    component: () => import('./views/summaryOfPayment'),
    meta: {
      title: '缴费清单汇总'
    }
  },
  {
    path: 'reconciliationReport',
    name: 'reconciliationReport',
    component: () => import('./views/reconciliationReport.vue'),
    meta: {
      title: '进出场对账报表'
    }
  },
  {
    path: 'regionalRentalInfo',
    name: 'regionalRentalInfo',
    component: () => import('./views/regionalRentalInfo'),
    meta: {
      title: '区域出租信息汇总表'
    }
  },
  {
    path: 'miscellaneousCharges',
    name: 'miscellaneousCharges',
    component: () => import('./views/miscellaneousCharges'),
    meta: {
      title: '杂费管理'
    }
  },
  {
    path: 'tricycleAccountManagement',
    name: 'tricycleAccountManagement',
    component: () => import('./views/tricycleAccountManagement'),
    meta: {
      title: '三轮车账户管理'
    }
  },
  {
    path: 'invoiceManagement',
    name: 'InvoiceManagement',
    component: () => import('./views/invoiceManagement.vue'),
    meta: {
      title: '发票管理'
    }
  },
  {
    path: 'invoiceFeeType',
    name: 'InvoiceFeeType',
    component: () => import('./views/invoiceFeeType.vue'),
    meta: {
      title: '发票费用项管理'
    }
  },
]
